import Vue from "vue";
import VueI18n from "vue-i18n";
import store from "@/store";
// import data from './messages.json'

Vue.use(VueI18n);

const messages = {
    en: require("@/locale/translations_en.json"),
    nl: require("@/locale/translations_nl.json")
};

export const i18n = new VueI18n({
    locale: store.state.app.locale, //Locale
    fallbackLocale: "en", //set fallback locale,
    messages
});
